// "Report a problem" modal, opened from the "!" button or the no-route notice.
// Collects a free-text message; the host attaches the session snapshot and
// sends it via onSubmit(message). Copy-out clean: no imports outside src/pathfinder.

import { useState } from 'react';

export default function ReportPopup({ onSubmit, onClose }) {
  const [text, setText] = useState('');
  const [done, setDone] = useState(false);

  const submit = () => {
    const v = text.trim();
    if (!v) return;
    onSubmit?.(v);
    setDone(true);
  };

  return (
    <div className="pfa-fb-backdrop" onClick={onClose}>
      <div className="pfa-fb-card" onClick={e => e.stopPropagation()}>
        <button className="pfa-fb-close" onClick={onClose} aria-label="Dismiss">✕</button>
        <div className="pfa-fb-title">Report a problem</div>
        {done ? (
          <div className="pfa-fb-thanks">Thanks — your report was sent!</div>
        ) : (
          <>
            <div className="pfa-fb-sub">
              Tell us what went wrong. Your current search details are attached
              automatically to help us debug.
            </div>
            <textarea
              className="pfa-report-text"
              autoFocus
              rows={4}
              maxLength={2000}
              placeholder="Describe the issue…"
              value={text}
              onChange={e => setText(e.target.value)}
            />
            <div className="pfa-fb-actions">
              <button className="pfa-fb-skip" onClick={onClose}>Cancel</button>
              <button className="pfa-fb-submit" disabled={!text.trim()} onClick={submit}>Send report</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
